import { IEnvironmentVariables } from '../models/environment.interface';

export const environment: IEnvironmentVariables = {
  production: true,
  test: false,
  debuggingEnabled: false,
  useMockConfig: false
};
